(() => {
  const shuffle = (cards) => {
    for (let index = cards.length - 1; index > 0; index -= 1) {
      const other = Math.floor(Math.random() * (index + 1));
      [cards[index], cards[other]] = [cards[other], cards[index]];
    }
    return cards;
  };

  const initialize = (carousel) => {
    if (carousel.dataset.discoveryReady) return;
    carousel.dataset.discoveryReady = 'true';

    const viewport = carousel.querySelector('[data-discovery-viewport]');
    const list = carousel.querySelector('[data-discovery-list]');
    const controls = carousel.querySelector('[data-discovery-controls]');
    const previous = carousel.querySelector('[data-discovery-previous]');
    const next = carousel.querySelector('[data-discovery-next]');
    const status = carousel.querySelector('[data-discovery-status]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let productCount = 0;
    let cloneCount = 0;
    let settleTimer;

    const positionOf = (card) => card.getBoundingClientRect().left - viewport.getBoundingClientRect().left + viewport.scrollLeft;
    const scrollToIndex = (index, behavior = 'auto') => {
      const card = list.children[index];
      if (card) viewport.scrollTo({ left: positionOf(card), behavior });
    };

    const nearestIndex = () => {
      let nearest = 0;
      let distance = Infinity;
      [...list.children].forEach((card, index) => {
        const difference = Math.abs(positionOf(card) - viewport.scrollLeft);
        if (difference < distance) {
          distance = difference;
          nearest = index;
        }
      });
      return nearest;
    };

    const jumpToIndex = (index) => {
      viewport.style.scrollSnapType = 'none';
      scrollToIndex(index);
      requestAnimationFrame(() => { viewport.style.scrollSnapType = ''; });
    };

    const settle = () => {
      if (!productCount) return;
      const index = nearestIndex();
      if (index < cloneCount) jumpToIndex(index + productCount);
      else if (index >= cloneCount + productCount) jumpToIndex(index - productCount);
    };

    const move = (direction) => {
      if (productCount < 2) return;
      let index = nearestIndex();
      if (index < cloneCount) index += productCount;
      else if (index >= cloneCount + productCount) index -= productCount;
      scrollToIndex(index + direction, reducedMotion.matches ? 'auto' : 'smooth');
    };

    const fetchPage = async (page) => {
      const url = new URL(carousel.dataset.discoveryFeedUrl, window.location.origin);
      url.searchParams.set('page', String(page));
      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) throw new Error(`Discovery feed returned ${response.status}`);
      const document = new DOMParser().parseFromString(await response.text(), 'text/html');
      const feed = document.querySelector('[data-discovery-feed]');
      if (!feed || Number(feed.dataset.page) !== page) throw new Error('Discovery feed is unavailable');
      return {
        pages: Number(feed.dataset.pages),
        cards: [...feed.querySelectorAll('[data-discovery-card]')]
      };
    };

    const load = async () => {
      status.hidden = false;
      try {
        const first = await fetchPage(1);
        if (!Number.isSafeInteger(first.pages) || first.pages < 1) throw new Error('Discovery feed has no pages');
        const cards = first.cards;
        // Limit concurrent requests while still reading every page of the public catalog.
        for (let page = 2; page <= first.pages; page += 4) {
          const requests = [];
          for (let current = page; current < Math.min(page + 4, first.pages + 1); current += 1) {
            requests.push(fetchPage(current));
          }
          const results = await Promise.all(requests);
          results.forEach((result) => cards.push(...result.cards));
        }

        const seen = new Set();
        const uniqueCards = shuffle(cards.filter((card) => {
          const id = card.dataset.productId;
          if (!id || seen.has(id)) return false;
          seen.add(id);
          return true;
        }));
        if (!uniqueCards.length) throw new Error('Discovery feed has no products');

        productCount = uniqueCards.length;
        cloneCount = Math.min(4, productCount);
        const clone = (card) => {
          const copy = card.cloneNode(true);
          copy.setAttribute('aria-hidden', 'true');
          copy.querySelectorAll('a').forEach((link) => { link.tabIndex = -1; });
          return copy;
        };
        list.replaceChildren(
          ...uniqueCards.slice(-cloneCount).map(clone),
          ...uniqueCards,
          ...uniqueCards.slice(0, cloneCount).map(clone)
        );
        jumpToIndex(cloneCount);
        controls.hidden = productCount < 2 || viewport.scrollWidth <= viewport.clientWidth + 2;
        status.hidden = true;
      } catch (error) {
        // Keep the server-rendered cards and the all-products link available.
        status.textContent = document.documentElement.lang.startsWith('ja')
          ? '商品を読み込めませんでした。すべての商品を見るからご覧ください。'
          : 'More products could not be loaded. Use View all products.';
        console.warn(error);
      }
    };

    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    viewport.addEventListener('scroll', () => {
      clearTimeout(settleTimer);
      settleTimer = setTimeout(settle, 150);
    }, { passive: true });
    window.addEventListener('resize', () => {
      if (productCount) jumpToIndex(nearestIndex());
    }, { passive: true });
    load();
  };

  document.querySelectorAll('[data-discovery-carousel]').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-discovery-carousel]').forEach(initialize);
  });
})();
